import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAttendanceByEmployeeList } from "../../Thunks/HeyTraderThunks";
import { EmployeeAttendanceType } from "../../Types/HeyTraderTypes/Attendances/EmployeeAttendanceType";

interface AttendanceEmployeeSliceState {
    loader: boolean; // for refres pages and inital loadings
    attendanceEmployeeList: EmployeeAttendanceType|null;
    errorDisplay: string | null;
}

// set inital valus
const initialState : AttendanceEmployeeSliceState = {
    loader: false,
    attendanceEmployeeList:null,
    errorDisplay: '',

}

// set state valu for api response
const attendanceSingleEmployeeSlice = createSlice ({
    name: 'attendanceSingleEmployee',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAttendanceByEmployeeList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAttendanceByEmployeeList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAttendanceByEmployeeList.fulfilled, (state, action: PayloadAction<EmployeeAttendanceType>) => {
                    state.loader = false;
                    state.attendanceEmployeeList = action.payload;
                  })
    }
})

export const {} = attendanceSingleEmployeeSlice.actions
export default attendanceSingleEmployeeSlice.reducer
